const o = "_disabled_6hld4_12", n = "_heroContainer_6hld4_12", t = "_wrapping_6hld4_37", _ = "_textContainer_6hld4_48", r = "_notWrapping_6hld4_53", a = "_infoIcon_6hld4_85", e = {
  "root-base": "_root-base_6hld4_1",
  disabled: o,
  heroContainer: n,
  "root-vertical": "_root-vertical_6hld4_21",
  "root-horizontal": "_root-horizontal_6hld4_29",
  wrapping: t,
  textContainer: _,
  notWrapping: r,
  infoIcon: a
};
export {
  e as default,
  o as disabled,
  n as heroContainer,
  a as infoIcon,
  r as notWrapping,
  _ as textContainer,
  t as wrapping
};
//# sourceMappingURL=index.es793.js.map
